'use client';

import { Button } from '@chemist4u/newt-components';
import { PLP_ERROR_MESSAGE } from '@modules/store/components/plp-live-status';

/** Failed-fetch fallback for the client-driven PLP grid — shown instead of
 * the misleading empty state (`0 of 0 products`) when the sort/filter/page
 * refetch rejects. Screen readers get the same message via `PlpLiveStatus`. */
export function ProductGridErrorState({ onRetry }: { onRetry: () => void }) {
  return (
    <div className="flex flex-col items-center justify-center py-16 text-center">
      <p className="text-lg font-medium text-fg-neutral-strong mb-2">
        {PLP_ERROR_MESSAGE}
      </p>
      <p className="text-sm text-fg-neutral-soft mb-6">
        Please check your connection and try again.
      </p>
      <Button variant="secondary" onClick={onRetry}>
        Try again
      </Button>
    </div>
  );
}
